var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 441,
    viewBox: "0 0 740 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20869 168.297C-3.45418 151.167 7.17414 132.95 24.8726 129.45L672.983 1.28442C689.47 -1.97576 705.418 8.94095 708.345 25.4895L738.553 196.283C741.038 210.331 733.285 224.186 720.012 229.418L190.657 438.066C179.63 442.412 167.078 439.859 158.626 431.551L61.0117 335.6C57.6103 332.256 55.055 328.15 53.558 323.622L2.20869 168.297Z",
    fill: "#2F2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPolygon);
export default __webpack_public_path__ + "static/media/hero-polygon.ac4f66a50d8249edd4d80634d85229f8.svg";
export { ForwardRef as ReactComponent };